<div class="or-pt-32-px or-mx-24-px action-push-modal">
  <div class="or-d-flex or-justify-content-center">
    <span class="or-head-xl or-mb-16-px or-text-align-center"
      >Stwórz swoją grupkę i niech gierki organizują się same!</span
    >
  </div>

  <img class="or-mb-20-px or-w-100-pc" src="assets/action-push/create-group.jpg" />

  <div class="or-text-lg or-mb-20-px">
    Przenieś swoją ekipę do Orlikfy aby automatycznie zapraszać skład do gierek oraz zezwolić na automatyczne
    akceptacje.
  </div>
  <div class="or-text-lg or-mb-20-px">
    W każdym momencie możesz upublicznić grę aby znaleźć dodatkowych graczy do waszej ekipy.
  </div>
</div>

<div class="or-mb-12-px or-mx-24-px or-mt-12-px">
  <button class="button-primary-style or-h-48-px or-head-md or-w-100-pc or-mb-12-px" (click)="handleAction()">
    Stwórz swoją grupkę!
  </button>

  <button class="button-secondary-style or-h-48-px or-head-md or-w-100-pc" (click)="closeModal()">
    Wróć do głównego ekranu
  </button>
</div>
